/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { CacheType, createObservableDataAction, IAction, IActionContext, IActionInput } from '@msdyn365-commerce/core';
import { createProductEnquiryAsync } from '../generated/DataActionExtension.g';
import { IDXC_ProductEnquiryResponse } from '../generated/DataServiceEntities.g';

/**
 * SubmitContactFormDataActionInput Input Action
 */

export class SubmitPdpEnquiryFormDataActionInput implements IActionInput {
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public storeName: string;
    public product: string;
    public enquiry: string;
    public customisations: string;
    public fabricType: string;
    public fabricColour: string;
    public consultationType: string;
    public channelId: string;
    public subscribeNewsletter: number;

    // Construct the input needed to run the action
    constructor(
        firstName: string,
        lastName: string,
        email: string,
        phone: string,
        storeName: string,
        product: string,
        enquiry: string,
        customisations: string,
        fabricType: string,
        fabricColour: string,
        consultationType: string,
        channelId: string,
        subscribeNewsletter: number) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.phone = phone;
        this.storeName = storeName;
        this.product = product;
        this.enquiry = enquiry;
        this.customisations = customisations;
        this.fabricType = fabricType;
        this.fabricColour = fabricColour;
        this.consultationType = consultationType;
        this.channelId = channelId;
        this.subscribeNewsletter = subscribeNewsletter;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => 'ContactForm2020';
    public getCacheObjectType = () => 'ContactForm';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: SubmitPdpEnquiryFormDataActionInput): IActionInput => {
    return args;
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function submitPdpEnquiryFormAction(
    input: SubmitPdpEnquiryFormDataActionInput,
    ctx: IActionContext
): Promise<IDXC_ProductEnquiryResponse> {
    // Input only needs token
    let result: IDXC_ProductEnquiryResponse = {success: false};
    try {
        result = await createProductEnquiryAsync(
            { callerContext: ctx },
            input.firstName,
            input.lastName,
            input.email,
            input.phone,
            input.storeName,
            input.product,
            input.enquiry,
            input.customisations,
            input.fabricType,
            input.fabricColour,
            input.consultationType,
            input.channelId,
            input.subscribeNewsletter);
    } catch (error) {
        console.log(error);
    }
    return Array.isArray(result) ? result[0] : result;
}

export const ISubmitPdpEnquiryFormDataActionAction = createObservableDataAction({
    action: <IAction<IDXC_ProductEnquiryResponse>>submitPdpEnquiryFormAction,
    input: createInput
});
